// 这里把常用打车数据转化成通用坐标点数据
export function commonlyToPosition(data) {
  return {
    Type: 2, // 2-目的地
    Name: data.productName,
    Address: data.arrivalInfo,
    IsAdsorb: 0,
    CityName: data.arrivalCityName,
    CityCode: data.arrivalCity,
    Longitude: data.lng,
    Latitude: data.lat,
  };
}
// 这里把上次打车数据转化成通用坐标点数据
export function lastAddressToPosition(data) {
  return {
    Type: 2, // 2-目的地
    Name: data.AddressName,
    Address: data.AddressDetail,
    IsAdsorb: 0,
    CityName: data.CityName,
    CityCode: data.CityId,
    Longitude: data.Lon,
    Latitude: data.Lat,
  };
}
